var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2ca0ff;}.cls-2{fill:#ff715d;}.cls-3{fill:#f4e211;}.cls-4{fill:#8dd463;}.cls-5{fill:#e1dacf;}.cls-6{fill:#2c2e2a;}.cls-7{clip-path:url(#clip-path);}.cls-12,.cls-22,.cls-8{fill:none;}.cls-12,.cls-21,.cls-22,.cls-25,.cls-8{stroke:#000;stroke-miterlimit:10;}.cls-21,.cls-22,.cls-25,.cls-8{stroke-linecap:round;}.cls-8{stroke-width:3px;}.cls-9{clip-path:url(#clip-path-2);}.cls-10{clip-path:url(#clip-path-3);}.cls-11{clip-path:url(#clip-path-4);}.cls-12,.cls-22,.cls-25{stroke-width:2px;}.cls-13{clip-path:url(#clip-path-5);}.cls-14{clip-path:url(#clip-path-6);}.cls-15{clip-path:url(#clip-path-7);}.cls-16,.cls-25{fill:#fff;}.cls-17{clip-path:url(#clip-path-8);}.cls-18{clip-path:url(#clip-path-9);}.cls-19{clip-path:url(#clip-path-10);}.cls-20{clip-path:url(#clip-path-11);}.cls-21{stroke-width:4px;}.cls-23{clip-path:url(#clip-path-12);}.cls-24{clip-path:url(#clip-path-13);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M698,297.3s-38.41-17.18-60.24-39.46a19.62,19.62,0,0,1-5.7-15.56,22.14,22.14,0,0,1,1.88-7,23.25,23.25,0,0,1,12.52-11.7,19.25,19.25,0,0,1,12.21-1h.06A39.68,39.68,0,0,1,670.87,228l-23.73-55.35a17.26,17.26,0,0,1,2.64-18.21,17,17,0,0,1,5.21-4,17.63,17.63,0,0,1,18.84,2.33,16.42,16.42,0,0,1,3.83,4.66c2.58,4.57,5.17,9.37,7.57,14.47a346.61,346.61,0,0,1,18.13,48l-16-65.26c-2.23-9.07,3.16-18.49,12.25-20.63.32-.08.66-.15,1-.21a18.85,18.85,0,0,1,8.33.37,16.75,16.75,0,0,1,10.74,9.28c1.42,3.07,2.8,6.24,4,9.55,3.84,10.49,9.12,27.65,14.88,54.38,0,0-2.71-35.46,2.86-45.1a15.69,15.69,0,0,1,31.1,2.29q1.66,6.08,3.64,12.4c2.3,7.39,5.59,17.15,9.51,26.65,0,0,23.13,43.58-15,81.69C770.67,285.4,739.69,313.82,698,297.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M832.81,537l-58.55-.25s-50.53-42.13-111.43-17.28L590.71,723s26.29,43.73,79.18,39.53c0,0,18.84-3.1,41.87,19.92,0,0,36.67,47.19,85-1.15C796.76,781.32,876.53,612.66,832.81,537Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1126.25,349.15s-26-75.22,58.73-114.7c0,0,68-31.64,178.17,78.58,22.36,24.15,33.25,54.51,23.72,74.16-13,26.73-67.28,40.92-120.71,7.95-3.26,2.65-36,28.45-78,17.19-30.24-8.09-53.91-32.33-61.92-63.18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1364.34,417.53a75.95,75.95,0,0,0-75.06-62.37c-8.47,0-18,2.16-22.46,9.34-3.62,5.79-2.94,13.16-2.14,19.93.89,7.46,1.91,15.29,6.36,21.35,4.85,6.62,12.94,10,20.77,12.4a169.46,169.46,0,0,0,70.51,6.47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M867.65,375.19c-2.66-1.42-53.28-29.52-51.23-77.52a69.51,69.51,0,0,1,4.25-20.95,77.19,77.19,0,0,1,18.74-28.4c24.45-23.85,102.82-84.32,215.85-15.88a37.8,37.8,0,0,1,6.67,5.06c18.62,17.79,25.71,43.68,18,65.1-10.63,29.7-48.54,47.74-84.73,34.28-3.54,6.86-17.76,32.47-49,44.5C909.19,395.65,876.5,379.94,867.65,375.19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1025.34,293.71c-10.29,1.8-20.54,6.22-27,14.38S990,328.65,996,337.21c5.28,7.57,15.06,10.59,24.25,11.36,18.91,1.6,38.17-4.77,52.88-16.64,18.56-15,5-29.32-13.12-35.43A70.65,70.65,0,0,0,1025.34,293.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1016,597.53s133.33-152,110.27-248.38c0,0,80.07-25.87,137.88,16.25a461,461,0,0,1-214.87,412.66c-46.69,4-89.12-27-99.19-71C939.36,660.3,968,611.33,1016,597.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M935.2,807.61s148.58,9.38,193-143.84c0,0,32.83-104.08-45.63-224.88,0,0-56.66-74.46-91.6-107.19,0,0-71.35-28.73-123.34,43.49a268.45,268.45,0,0,1,55.19,200.56c-57.77,24.32-89.77,84-78.32,139.41,9.11,44,44.53,79.84,90.68,92.45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M791,585.43s79.81-45,189.73,1.61c115.61,49.07,80,222.07-45.57,220.57-46.27-.56-105.32-14.28-180.64-49.2C754.56,758.41,725.52,666,791,585.43Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405,742.11s-9-55.06-105-56.35a19.32,19.32,0,0,0-10.62,2.85c-4.59,2.91-9.11,8.56-5.78,19.19,0,0-5.49-6.47-10.49-13.2a25.27,25.27,0,0,0-27.6-9.38c-10.1,3.14-18.14,16.8-12.52,44,0,0-36.2,23.59.8,65.62,0,0-21.77,36.74,41.85,57.73a201.18,201.18,0,0,0,38.71,4.3c59.57.94,104.92-54.36,91.3-112.36C405.36,743.75,405.16,742.93,405,742.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 602.2,
    cy: 539.07,
    r: 67.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 642.09,
    cy: 527.41,
    r: 13.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565.59,537c3.39,8.36-.89,16.28-5.65,17.53-4.58,1.19-11.79-3.2-13.45-11.55Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "exchange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Steel_mug",
    "data-name": "Steel mug"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.27,727.1c7.15,32.75,35.63,54.34,63.62,48.23s44.89-37.61,37.74-70.35S249,650.65,221,656.76,176.12,694.36,183.27,727.1ZM198,723.89c-5.07-23.23,6.92-45.58,26.78-49.91s40.07,11,45.14,34.21-6.92,45.58-26.78,49.92S203.06,747.12,198,723.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.1,638.85l27.47,125.83c7.8,35.72-12.61,71.78-47.42,82.93-4.49,1.44-9.19,2.76-14.09,3.92a188.44,188.44,0,0,1-20.64,3.7,71.17,71.17,0,0,1-78.11-55.52L56.84,673.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 136.97,
    cy: 656.35,
    rx: 82.02,
    ry: 26.32,
    transform: "translate(-136.83 44.31) rotate(-12.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 136.95,
    cy: 655.43,
    rx: 71.62,
    ry: 19.23,
    transform: "translate(-136.63 44.29) rotate(-12.31)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "left_fingers",
    "data-name": "left fingers"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M698,297.3s-38.41-17.18-60.24-39.46a19.62,19.62,0,0,1-5.7-15.56,22.14,22.14,0,0,1,1.88-7,23.25,23.25,0,0,1,12.52-11.7,19.25,19.25,0,0,1,12.21-1h.06A39.68,39.68,0,0,1,670.87,228l-23.73-55.35a17.26,17.26,0,0,1,2.64-18.21,17,17,0,0,1,5.21-4,17.63,17.63,0,0,1,18.84,2.33,16.42,16.42,0,0,1,3.83,4.66c2.58,4.57,5.17,9.37,7.57,14.47a346.61,346.61,0,0,1,18.13,48l-16-65.26c-2.23-9.07,3.16-18.49,12.25-20.63.32-.08.66-.15,1-.21a18.85,18.85,0,0,1,8.33.37,16.75,16.75,0,0,1,10.74,9.28c1.42,3.07,2.8,6.24,4,9.55,3.84,10.49,9.12,27.65,14.88,54.38,0,0-2.71-35.46,2.86-45.1a15.69,15.69,0,0,1,31.1,2.29q1.66,6.08,3.64,12.4c2.3,7.39,5.59,17.15,9.51,26.65,0,0,23.13,43.58-15,81.69C770.67,285.4,739.69,313.82,698,297.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M671.13,228.6a13.44,13.44,0,0,1,16.79,15.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M710.31,218.48a11.89,11.89,0,0,0-14.17,6.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M747.58,208.08a11.73,11.73,0,0,0-16.11,2.43"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "left_hand",
    "data-name": "left hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.29,540c16.81-37.58,51.49-136.91,6.88-241.9a55.71,55.71,0,0,0-57.28-33.76c-.66.07-1.32.16-2,.25l-.68.1a47.33,47.33,0,0,0-40.09,46.41c-.16,13.84-1,30.31-2.53,48.67C676,403,667.05,458.05,645.42,505.56c-17,37.29,7.89,80.77,48.73,84.11l2.28.15a78.14,78.14,0,0,0,35.33-6.35A84.75,84.75,0,0,0,775.29,540Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M832.81,537l-58.55-.25s-50.53-42.13-111.43-17.28L590.71,723s26.29,43.73,79.18,39.53c0,0,18.84-3.1,41.87,19.92,0,0,36.67,47.19,85-1.15C796.76,781.32,876.53,612.66,832.81,537Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838.88,530.39s-150.2,126-64.62,274.19l28.38-19.27,47.4-106,11.57-92.22Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 775.29,
    y1: 539.95,
    x2: 744.8,
    y2: 536.7
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "left_shoe",
    "data-name": "left shoe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1126.25,349.15s-26-75.22,58.73-114.7c0,0,68-31.64,178.17,78.58,22.36,24.15,33.25,54.51,23.72,74.16-13,26.73-67.28,40.92-120.71,7.95-3.26,2.65-36,28.45-78,17.19-30.24-8.09-53.91-32.33-61.92-63.18"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1151,310.24c7.61-9.81,7.46-24.87-.33-34.53,21-12.07,46.12-15.93,70.2-13.32s47.17,11.44,68.31,23.26a254,254,0,0,1,86.73,80c-4.28,5.78-6.41,13.54-4.06,20.34s9.94,11.85,16.89,10c4.9-1.31,8.56-5.63,10.26-10.4s1.71-10,1.35-15c-3-41.74-29.3-78.68-61.1-105.87-22.72-19.43-49-35.22-77.76-43.23s-60.29-7.85-88,3.32-51.2,33.91-60.51,62.31c-3.26,9.95-4.35,26.59,6.94,32.45C1129.77,324.65,1144.76,318.28,1151,310.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1364.34,417.53a75.95,75.95,0,0,0-75.06-62.37c-8.47,0-18,2.16-22.46,9.34-3.62,5.79-2.94,13.16-2.14,19.93.89,7.46,1.91,15.29,6.36,21.35,4.85,6.62,12.94,10,20.77,12.4a169.46,169.46,0,0,0,70.51,6.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1341.66,
    cy: 401.79,
    r: 4.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1322.1,
    cy: 381.68,
    r: 4.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1295.96,
    cy: 371.9,
    r: 4.51
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "right_shoe",
    "data-name": "right shoe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M867.65,375.19c-2.66-1.42-53.28-29.52-51.23-77.52a69.51,69.51,0,0,1,4.25-20.95,77.19,77.19,0,0,1,18.74-28.4c24.45-23.85,102.82-84.32,215.85-15.88a37.8,37.8,0,0,1,6.67,5.06c18.62,17.79,25.71,43.68,18,65.1-10.63,29.7-48.54,47.74-84.73,34.28-3.54,6.86-17.76,32.47-49,44.5C909.19,395.65,876.5,379.94,867.65,375.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.74,292.77c24.07-35.43,68.18-53.63,111-54.47s84.58,13.63,123.07,32.42c-5.44,9.51-1.56,23.15,8.07,28.37s23.18,1,28.18-8.72c6.29-12.28-.91-27.08-9.26-38.07-29.62-39-76.41-64.52-125.27-68.24s-99,14.38-134.16,48.47c-15.54,15.05-28.55,33.76-32.27,55.07-2.59,14.86,2.38,58.84,25.53,56.18C854,340.88,851.47,303.1,833.74,292.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1025.34,293.71c-10.29,1.8-20.54,6.22-27,14.38S990,328.65,996,337.21c5.28,7.57,15.06,10.59,24.25,11.36,18.91,1.6,38.17-4.77,52.88-16.64,18.56-15,5-29.32-13.12-35.43A70.65,70.65,0,0,0,1025.34,293.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1060.61,
    cy: 310.87,
    r: 4.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1036.01,
    cy: 307.19,
    r: 4.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1010.32,
    cy: 313.03,
    r: 4.17
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "left_leg",
    "data-name": "left leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1016,597.53s133.33-152,110.27-248.38c0,0,80.07-25.87,137.88,16.25a461,461,0,0,1-214.87,412.66c-46.69,4-89.12-27-99.19-71C939.36,660.3,968,611.33,1016,597.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1222.89,333.36s69.37,278.09-210.84,381l-21.62-38.12s236-52.3,201.88-349.67Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "right_leg",
    "data-name": "right leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M935.2,807.61s148.58,9.38,193-143.84c0,0,32.83-104.08-45.63-224.88,0,0-56.66-74.46-91.6-107.19,0,0-71.35-28.73-123.34,43.49a268.45,268.45,0,0,1,55.19,200.56c-57.77,24.32-89.77,84-78.32,139.41,9.11,44,44.53,79.84,90.68,92.45"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M943.11,317.32s177.58,147.4,89,323.57l-51.93-36.56S1051.3,470.59,908.75,328Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1101.1,470.9s106.1,183.79-51.84,307.16"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "right_thigh",
    "data-name": "right thigh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M791,585.43s79.81-45,189.73,1.61c115.61,49.07,80,222.07-45.57,220.57-46.27-.56-105.32-14.28-180.64-49.2C754.56,758.41,725.52,666,791,585.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M986.36,589.57s-28.92,116.26-245,67.77l-2.86,42.31s202,112.39,301.23-75.43c0,0-5-56.84-53.41-34.65"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 923.55,
    y1: 569.77,
    x2: 929.84,
    y2: 606.56
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "right_hand",
    "data-name": "right hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M733.32,578.2c-10.85-27.92-41.57-42.6-70.37-34.37-27.5,7.86-66.36,27.52-106.3,75.68,0,0-58.15,68.16-147,101.62a55.37,55.37,0,0,0-36.17,57.35c.06.61.12,1.21.2,1.81,3.1,24.72,23.55,43.64,48.38,45.8,36.3,3.17,65.89.09,86.21-4.87C570.44,806,651.1,763,724.91,651.74c13.6-20.51,17.59-46.14,9.86-69.5-.22-.69-.46-1.37-.71-2.06S733.58,578.85,733.32,578.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M632.29,757.05A327.69,327.69,0,0,0,667.76,724"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "right_fingers",
    "data-name": "right fingers"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405,742.11s-9-55.06-105-56.35a19.32,19.32,0,0,0-10.62,2.85c-4.59,2.91-9.11,8.56-5.78,19.19,0,0-5.49-6.47-10.49-13.2a25.27,25.27,0,0,0-27.6-9.38c-10.1,3.14-18.14,16.8-12.52,44,0,0-36.2,23.59.8,65.62,0,0-21.77,36.74,41.85,57.73a201.18,201.18,0,0,0,38.71,4.3c59.57.94,104.92-54.36,91.3-112.36C405.36,743.75,405.16,742.93,405,742.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M232.89,729.27s24.84,47.13,79.62,51.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M233.69,794.89s30.49,23.83,73,25.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M283.5,707.8s8.39,17.23,38,26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M322.48,734.18a18,18,0,0,0,25.43,18.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M317.65,772.9a16.71,16.71,0,0,0-3.54,17.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M308.92,813.81a15.06,15.06,0,0,0,.34,16"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M703.67,218.7,683,170.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M738.15,205.58A220.39,220.39,0,0,0,724,154.44"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Face"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 602.2,
    cy: 539.07,
    r: 67.49
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M572.37,489.68c4.14,6.1,12.77,8.23,19.74,5.81,3.81-1.32,7.11-3.76,10.64-5.71s7.62-3.42,11.56-2.57,7.4,4.81,6.44,8.73c-1,4.13-6.22,6.58-6.32,10.83-.08,3,2.52,5.38,5.31,6.36s5.82.94,8.74,1.43,6,1.7,7.4,4.29c1.33,2.43.87,5.46-.21,8s-2.73,4.81-3.84,7.34c-2.93,6.74-1.57,14.9,2.61,20.94s10.88,10,18,11.91c6.29,1.66,13.46,1.59,18.74-2.2s7.61-10.55,8.72-17c4.44-25.58-6.28-53.22-26.81-69.12a73.87,73.87,0,0,0-62.81-12.5c-4.47,1.16-11,1.64-14.83,4.3C569.67,474.46,568.61,484.16,572.37,489.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M553.68,512.84s-11.53,14.28-1.13,18.84"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 579.38,
    cy: 531.71,
    r: 5.3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 642.09,
    cy: 527.41,
    r: 13.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M647.8,523.52a8.84,8.84,0,0,0-12.38,1"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "left_eyebrow",
    "data-name": "left eyebrow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.91,
    cy: 509.07,
    rx: 4.34,
    ry: 7.51,
    transform: "translate(-165.98 709.29) rotate(-56.51)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "right_eyebrow",
    "data-name": "right eyebrow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 550.02,
    cy: 496.15,
    rx: 4.1,
    ry: 7.03,
    transform: "translate(6.97 999.92) rotate(-84.9)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "left_eye",
    "data-name": "left eye"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 566.53,
    cy: 519.42,
    r: 3.48
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "right_eye",
    "data-name": "right eye"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 545.08,
    cy: 506.69,
    r: 2.98
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565.59,537c3.39,8.36-.89,16.28-5.65,17.53-4.58,1.19-11.79-3.2-13.45-11.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M554.77,550.8c-1.29.93-2.46,2.37-2.25,4a3.76,3.76,0,0,0,2.7,2.85,10.76,10.76,0,0,0,4.12.22,18,18,0,0,0,4.21-.65,6.24,6.24,0,0,0,3.41-2.44,4.64,4.64,0,0,0,.38-4.07c-.57-1.12-2.12-1.46-3.25-1.71A11.77,11.77,0,0,0,554.77,550.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M561.87,536.1l0,.09a6.4,6.4,0,0,1-4.21,7.89l-.77.24a6.39,6.39,0,0,1-8-4.09h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange01);
export default __webpack_public_path__ + "static/media/exchange-01.6b05f4cdda7df91070a0b2252f20506d.svg";
export { ForwardRef as ReactComponent };